import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
  standalone:false
})
export class TimelineComponent {
 @Input() items: TimelineItem[] = [];
  @Input() vertical: boolean = true;
}

export interface TimelineItem {
  label: string;
  date?: string;
  description?: string;
  status?: 'done' | 'in-progress' | 'pending';
  icon?: string; // Bootstrap icon class or Font Awesome class
}
